import groq from 'groq';
import { ComponentType, EntityType } from '$lib/sanity/types';
import { PageHierarchyItemsFragment } from './pageHierarchy';
import { ModalLayoutFragment } from './modal';
import { ImageComponentFragment } from './image';

export const RichTextFragment = groq`
    ...,
    ${ImageComponentFragment},
    links,
    starButton,
    forkButton,
    followButton,
    markDefs[] {
      ...,
      defined(page) => {
        page->{
          _id,
          _type,
          name,
          slug,
          _type == "${EntityType.Page}" => {
            ${PageHierarchyItemsFragment},
          },
          _type == "${EntityType.NewsTopicPage}" => {
            topic->{slug}
          },
        },
      },
      ${ModalLayoutFragment},
    }
`;

export const TextComponentFragment = groq`
  defined(body) => {
    body[] {
      ${RichTextFragment}
    },
    'bodyRef': body
  }
`;

export const GetTextQuery = groq`
  *[_type == "${ComponentType.Text}" && _id == $id]{
    ...,
    ${TextComponentFragment}
  }[0]
`;
